import PrimeVueBaseStyle from '@primevue/core/base/style';
import PrimeConfig from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import { createApp } from 'vue';

import {
  RygenUiPrimeVueConfig,
  rygenUiPrimeVueConfiguration,
} from '@rygen/rygen-ui/config/PrimeVueConfig';
import environmentPropertiesStore from '@rygen/rygen-ui/env/EnvironmentPropertiesStore';
import { AuthorizationPlugin } from '@rygen/rygen-ui/plugins/AuthorizationPlugin';

import '@/assets/style/main.scss';
import '@/assets/style/variables.css';

import { installAuthProvider } from '@/config/AuthProviderInstaller';
import { cacheBusting } from '@/config/CacheBustingInstaller';
import { environmentProperties } from '@/config/EnvironmentPropertiesInstaller';
import { errorHandling } from '@/config/ErrorHandlingInstaller';
import { fontAwesome } from '@/config/FontAwesomeInstaller';
import { unleash } from '@/config/UnleashInstaller';
import i18n from '@/i18n';
import router from '@/router';
import pinia from '@/stores';

import App from './App.vue';
import { applyBlockUITempFix } from './plugins/primevue-blockui-temp-fix';

(PrimeVueBaseStyle as any)?.loadCSS?.();

// TODO: CRITICAL - Monkey patch for PrimeVue BlockUI bug
// See: src/plugins/primevue-blockui-temp-fix.ts
// PR: https://github.com/primefaces/primevue/pull/8347
// Remove when upgrading to PrimeVue >= 4.6.0
applyBlockUITempFix();

const app = createApp(App)
  .use(AuthorizationPlugin)
  .use(environmentProperties)
  .use(errorHandling)
  .use(fontAwesome)
  .use(PrimeConfig, rygenUiPrimeVueConfiguration)
  .use(RygenUiPrimeVueConfig, rygenUiPrimeVueConfiguration)
  .use(ConfirmationService)
  .use(ToastService)
  .use(unleash)
  .use(pinia)
  .use(i18n)
  .use(cacheBusting);

installAuthProvider(environmentPropertiesStore.getProperties()).finally(() => {
  app.use(router);
  app.mount('#app');
});
